import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * svg画像からiconを作成する
 * @export
 * @class MakeIconService
 */
@Injectable({
  providedIn: 'root'
})
export class MakeIconService {

  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer,) { }

  public makeIcon() {
    this.matIconRegistry.addSvgIcon(
        'ff_navi', this.domSanitizer.bypassSecurityTrustResourceUrl('outer-assets/sg-features/icon/cursus/icon_navi2.svg'));
    this.matIconRegistry.addSvgIcon(
        'prov_navi', this.domSanitizer.bypassSecurityTrustResourceUrl('outer-assets/sg-features/icon/cursus/icon_navi3.svg'));
    this.matIconRegistry.addSvgIcon(
        'eec_navi', this.domSanitizer.bypassSecurityTrustResourceUrl('outer-assets/sg-features/icon/cursus/icon_navi4.svg'));
    this.matIconRegistry.addSvgIcon(
        'bill-navi', this.domSanitizer.bypassSecurityTrustResourceUrl('outer-assets/sg-features/icon/cursus/icon_navi5.svg'));
    this.matIconRegistry.addSvgIcon(
        'sys_navi', this.domSanitizer.bypassSecurityTrustResourceUrl('outer-assets/sg-features/icon/cursus/icon_navi6.svg'));
    this.matIconRegistry.addSvgIcon(
        'sg_kb_navi', this.domSanitizer.bypassSecurityTrustResourceUrl('outer-assets/sg-features/icon/cursus/icon_navi2.svg'));
    this.matIconRegistry.addSvgIcon(
        'sg_kc_navi', this.domSanitizer.bypassSecurityTrustResourceUrl('outer-assets/sg-features/icon/cursus/icon_navi4.svg'));
    this.matIconRegistry.addSvgIcon(
        'sg_kd_navi', this.domSanitizer.bypassSecurityTrustResourceUrl('outer-assets/sg-features/icon/cursus/icon_navi5.svg'));
  }
}